import { render, staticRenderFns } from "./Debt.vue?vue&type=template&id=0495f295&"
import script from "./Debt.vue?vue&type=script&lang=js&"
export * from "./Debt.vue?vue&type=script&lang=js&"
import style0 from "./Debt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Debt.vue"
export default component.exports